/** @file Reads rig slots into SlotData: packed colours, blend codes and interned setup placeholders. */
import type { Pose2DJson } from '@pose2d/format/types';
import type { Blend, SlotData } from '../../skeletonData';
import type { Interner } from './createInterner';
import { indexIn } from './indexIn';
import { packHex } from './packHex';

const WHITE = '#ffffffff';
/** A slot without `dark` gets black: tint-black with a black dark colour leaves the light colour unchanged. */
const NO_DARK = '#000000';

/** Slots in setup draw order; `attachment` is a placeholder id (interned here) or -1. */
export function readSlots(slots: Pose2DJson['slots'], boneCount: number, placeholders: Interner): SlotData[] {
  return slots.map((s, i): SlotData => {
    const setup = s.attachment ?? null;
    return {
      name: s.name,
      bone: indexIn(s.bone, boneCount, `slots[${i}].bone`),
      blend: indexIn(s.blend ?? 0, 4, `slots[${i}].blend`) as Blend,
      color: packHex(s.color ?? WHITE, `slots[${i}].color`),
      dark: packHex(s.dark ?? NO_DARK, `slots[${i}].dark`),
      attachment: setup === null ? -1 : placeholders.intern(setup),
    };
  });
}
